import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import {
  OPERATING_AREAS,
  regionLabel,
  UNCOVERED_OPERATING_AREAS,
} from "../utils/regions";

/** Read-only: it tells which operating area the plant sits in, it does not switch anything. */
export default function RegionIndicator({ region }: { region: string | null }) {
  const areas =
    region && !OPERATING_AREAS.includes(region)
      ? [...OPERATING_AREAS, region]
      : OPERATING_AREAS;

  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      size="small"
      color="primary"
      value={region}
      aria-label="Operating area of the plant"
      sx={{ bgcolor: "background.paper", pointerEvents: "none" }}
    >
      {areas.map((area) => {
        const uncovered = UNCOVERED_OPERATING_AREAS.includes(area);
        return (
          <ToggleButton
            key={area}
            value={area}
            disabled={uncovered}
            sx={{
              fontWeight: 600,
              textTransform: "none",
              // Filled grey reads as "out of scope for now", not as an empty option.
              ...(uncovered && {
                "&.Mui-disabled": {
                  bgcolor: "action.disabledBackground",
                  color: "text.disabled",
                },
              }),
            }}
          >
            {regionLabel(area)}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
}
